import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RouteRecoveryComponent } from './components/route-recovery/route-recovery.component';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouteRecoveryComponent],
  template: `<app-route-recovery /><router-outlet />`,
})
export class App {
  constructor() {
    inject(AnalyticsService).init();
  }
}
